import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import HLine from "../../components/components/hline";
import { Heading } from "../../components/components/text";
import { Formik, Field, Form, ErrorMessage } from "formik";

export default function Search() {
  const location = useLocation();
  const initialValues = {
    username: "",
    password: "",
  };
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  return (
    <>
      <HLine />
      <Heading>{location.pathname.substring(1)}</Heading>
      <HLine />
      <Formik initialValues={initialValues} onSubmit={() => {}}>
        <Form>
          <div className="form-group">
            <div>Search character:</div>

            <Field name="search" type="text" className="form-control" />
            <ErrorMessage
              name="search"
              component="div"
              className="alert alert-danger"
            />
          </div>

          <div className="form-group register-button">
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Search</span>
            </button>
          </div>

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
        </Form>
      </Formik>
    </>
  );
}
